import { createActions, createReducer } from 'reduxsauce'
import Immutable from 'seamless-immutable'
import { omit } from 'lodash'

export const INITIAL_STATE = Immutable({
  data: {},
  loaded: false,
})

const { Types, Creators } = createActions({
  getQuantityPromotions: null,

  setLoaded: ['val'],
  setQuantityPromotions: ['data'],

  saveQuantityPromotion: ['data'],
  deleteQuantityPromotion: ['promotion'],
})

export const saveQuantityPromotionReducer = (state, { data }) =>
  state.setIn(['data', data.key], data)

export const deleteQuantityPromotionReducer = (state, { promotion }) =>
  state.set('data', omit(state.data, promotion.key))

export const setLoadedReducer = (state, { val }) => state.set('loaded', val)

export const setQuantityPromotionsReducer = (state, { data }) => state.set('data', data)

export const quantityPromotionReducer = createReducer(INITIAL_STATE, {
  [Types.SET_LOADED]: setLoadedReducer,
  [Types.SET_QUANTITY_PROMOTIONS]: setQuantityPromotionsReducer,
  [Types.SAVE_QUANTITY_PROMOTION]: saveQuantityPromotionReducer,
  [Types.DELETE_QUANTITY_PROMOTION]: deleteQuantityPromotionReducer,
})

export const QuantityPromotionTypes = Types
export default Creators



// WEBPACK FOOTER //
// ./src/reducers/quantityPromotionReducer.js